import { useState } from 'react'

const useUpdateUser = () => {
	const [loading, setLoading] = useState(false)
	const user = JSON.parse(localStorage.getItem('user'))
	const updateUser = async (values) => {
		setLoading(true)
		console.log({ values })
		const response = await fetch(`${process.env.REACT_APP_BACKEND_BASE_URL}users/update`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json;charset=utf-8' },
			body: JSON.stringify({ _id: user._id, ...values, profilePicture: values?.profilePicture?.[0]?.url }),
		})
		// console.log({ response })
		setLoading(false)
		return response
	}

	return [updateUser, loading]
}

export default useUpdateUser
